import { render, staticRenderFns } from "./depositosTodepositos.vue?vue&type=template&id=6757e460"
import script from "./depositosTodepositos.vue?vue&type=script&lang=js"
export * from "./depositosTodepositos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports